module.exports = __webpack_public_path__ + "static/media/communicateInSeconds.21e5a779.svg";